module.exports = __webpack_public_path__ + "165818ef73fe9501d475596799024527.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-global.jpg
// module id = 22
// module chunks = 0